import React, { memo } from "react";
import { useCustomDatePickerToolbar } from "./index.hooks";
import { Collapse, Grid, TextField } from "@material-ui/core";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import * as adapter from "@material-ui/pickers/adapter/moment";
import moment from "moment";
import {
  DateFilterTypes,
  StatsFilters,
} from "../../redux-store/slices/stats/interfaces";
import { AppButton } from "../index";

type CustomDatePickerToolbarProps = {};

export const CustomDatePickerToolbar = memo(
  ({}: CustomDatePickerToolbarProps) => {
    const {
      styles,
      classes,
      atomicStyles,
      t,
      dateFilterType,
      statsFilters,
      onChangeFilter,
      handleSubmitFilters,
      isMobile,
    } = useCustomDatePickerToolbar();

    return (
      <Collapse in={dateFilterType === DateFilterTypes.CUSTOM}>
        <Grid
          container
          spacing={2}
          direction={isMobile ? "column" : "row"}
          alignItems={isMobile ? "flex-start" : "center"}
          className={styles.gridContainer}
        >
          <Grid item>
            <LocalizationProvider dateAdapter={adapter.default}>
              <DatePicker
                label={t("Data di inizio")}
                openTo="year"
                views={["year", "month", "date"]}
                value={statsFilters[StatsFilters.START_DATE]}
                onChange={(newValue) => {
                  onChangeFilter(
                    StatsFilters.START_DATE,
                    moment(newValue).format(),
                  );
                }}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item>
            <LocalizationProvider dateAdapter={adapter.default}>
              <DatePicker
                label={t("Data di fine")}
                openTo="year"
                views={["year", "month", "date"]}
                value={statsFilters[StatsFilters.END_DATE]}
                onChange={(newValue) => {
                  onChangeFilter(
                    StatsFilters.END_DATE,
                    moment(newValue).format(),
                  );
                }}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item>
            <AppButton
              variant="contained"
              color="primary"
              className={styles.submitButton}
              onClick={handleSubmitFilters}
            >
              {t("Applica")}
            </AppButton>
          </Grid>
        </Grid>
      </Collapse>
    );
  },
);
